import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../common/Navbar";
import ContactUs from "../common/ContactUs";
import Footer from "../common/Footer";

const ServicesPage = () => {
  useEffect(() => {
    document.title = "Services";
  }, []);
  return (
    <div className="bg-white text-dark" style={{ fontFamily: 'Arial, sans-serif' }}>
      {/* Header */}
     <Navbar/>

      {/* Hero Section */}
      <section className="hero-motion-section text-center bg-light" style={{padding:'100px 0px'}}>
        <div className="container hero-motion-container">
          <h1 className="display-3" id="main-font">We Prepare Your</h1>
          <h1 className="display-5" id="main-font">Legal Motion</h1>
          <p className="mt-4 mb-0">
              ProSlay uses AI to help you draft legal motions easily.
          </p>
          <Link className="btn btn-outline-dark mt-3 py-2" to="/register" id="main-font">Get Started</Link>
        </div>
      </section>


      <section className="text-center py-5">
        <div className="container py-5">
          <h1 className="display-4" id="main-font">Our Services</h1>
          <h4 className="display-5" id="main-font">We specialize in creating high-quality legal motions.</h4>
          <p className="">Simply provide the details of your case, and we do the rest </p>
        </div>
      </section>

        <section className="py-5 bg-light">
          <div className="container">
            <div className="row">
              <div className="col-md-2"></div>
              <div className="ps-5 col-md-4">
                <h1 className="display-5" id="main-font">Motion to Compel</h1>
                <p className="">
                  If you're dealing with uncooperative parties, let us craft a clear, compelling motion to compel action.
                </p>
              </div>
              <div className="ps-5 col-md-4">
                <h1 className="display-5" id="main-font">Motion to Dismiss</h1>
                <p className="">
                  We can prepare a strong motion to dismiss, outlining compelling reasons your case should be dismissed.
                </p>
              </div>
              <div className="col-md-2"></div>
            </div>
            <div className="row mt-4">
              <div className="col-md-2"></div>
              <div className="ps-5 col-md-4">
                <h1 className="display-5" id="main-font">Motion for Continuance</h1>
                <p className="">
                  When you need more time to prepare your case, trust us to draft a persuasive motion for continuance.
                </p>
              </div>
              <div className="ps-5 col-md-4">
                <h1 className="display-5" id="main-font">Motion for Discovery</h1>
                <p className="">
                  We'll create a motion for discovery to ensure you have access to all the evidence you need.
                </p>
              </div>
              <div className="col-md-2"></div>
            </div>
          </div>
        </section>

      {/* <section className="text-center pb-5">
        <div className="container pt-1 -group">
          <p className="">We specialize in creating high-quality legal motions.</p>
          <p className="">Simply provide the details of your case, and we do the rest.</p>
        </div>
      </section> */}

      
      {/* Contact Section */}
       <ContactUs/>
       <Footer/>
    </div>
  );
};

export default ServicesPage;
